import React from "react";
import ReportErrorsByPartners from "../../../features/reports/rcs/report-errors-by-partner/components/ReportErrorsByPartner";

const _ReportRCSErrorsByPartners = () => {
  return <ReportErrorsByPartners />;
};

export default _ReportRCSErrorsByPartners;
